import { PDFViewer } from "../components/PDFViewer";
import { useGetFoodMenuQuery } from "click-and-collect/api/foodMenu.api";
import { EventHeader } from "event/play/components/EventHeader";

interface ClickAndCollectPDFViewProps {
  foodMenuId: string;
}

export function ClickAndCollectPDFView({
  foodMenuId,
}: ClickAndCollectPDFViewProps) {
  const { data, isSuccess } = useGetFoodMenuQuery(foodMenuId!);

  return (
    <>
      <EventHeader />
      {isSuccess && data && data.document ? (
        <PDFViewer pdfFileUrl={data.document} />
      ) : null}
    </>
  );
}
